import { clientEnv } from '@/shared/config/env';
import { requestJson } from '@/shared/request/http-client';

export interface ScratchCard {
  cardKey: string;
  qty: number;
  title: string;
}

export interface ScratchPending {
  cardKey: string;
  clientRequestNo: string;
  title: string;
}

export interface ScratchAlbum {
  canClaimSet: boolean;
  cards: ScratchCard[];
  jackpotMinor: number;
  needFirstDeposit: boolean;
  pending: ScratchPending | null;
  tickets: number;
}

export interface ScratchDrawResult {
  cardKey: string;
  clientRequestNo: string;
  duplicate: boolean;
  qtyAfter: number;
  status: 'CONFIRMED' | 'OPENED';
  ticketsAfter: number;
  title: string;
}

export interface ScratchClaimSetResult {
  canClaimSet: boolean;
  cards: ScratchCard[];
  duplicate: boolean;
  rewardMinor: number;
}

const siteQuery = () => `siteId=${encodeURIComponent(clientEnv.siteId)}`;

const scratchBody = (clientRequestNo: string) => ({
  clientRequestNo,
  siteId: clientEnv.siteId,
});

export const getScratchAlbum = (authToken: string) =>
  requestJson<ScratchAlbum>(`/v1/app/scratch/album?${siteQuery()}`, {
    authToken,
    method: 'GET',
  });

export const openScratch = (authToken: string, clientRequestNo: string) =>
  requestJson<ScratchDrawResult, { clientRequestNo: string; siteId: string }>(
    '/v1/app/scratch/open',
    {
      authToken,
      body: scratchBody(clientRequestNo),
      method: 'POST',
    },
  );

export const confirmScratch = (authToken: string, clientRequestNo: string, cardKey: string) =>
  requestJson<ScratchDrawResult, { cardKey: string; clientRequestNo: string; siteId: string }>(
    '/v1/app/scratch/confirm',
    {
      authToken,
      body: { ...scratchBody(clientRequestNo), cardKey },
      method: 'POST',
    },
  );

export const claimScratchSet = (authToken: string, clientRequestNo: string) =>
  requestJson<ScratchClaimSetResult, { clientRequestNo: string; siteId: string }>(
    '/v1/app/scratch/claim-set',
    {
      authToken,
      body: scratchBody(clientRequestNo),
      method: 'POST',
    },
  );

export const newScratchRequestNo = (prefix: 's' | 'c') =>
  `${prefix}${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
